import { render, staticRenderFns } from "./AgentStudentManager.vue?vue&type=template&id=c1264760&scoped=true&"
import script from "./AgentStudentManager.vue?vue&type=script&lang=js&"
export * from "./AgentStudentManager.vue?vue&type=script&lang=js&"
import style0 from "./AgentStudentManager.vue?vue&type=style&index=0&id=c1264760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1264760",
  null
  
)

export default component.exports